export const controlType = {
  Autofill: 'Autofill',
  MUIDatePicker: 'MUIDatePicker',
  DateRangePicker: 'DateRangePicker',
  DatePicker: 'DatePicker',
  DropDown: 'Dropdown',
  TextBox: 'TextBox',
  MultiSelectDropDown: 'MultiSelectDropDown',
  Checkbox: 'CheckBox',
  RadioButton: 'Radio',
  Switch: 'Switch',
  File: 'File',
  FileInput: 'FileInput',
  PhoneNumber: 'PhoneNumber',
  Email: 'Email',
  Chip: 'Chip',
  JSONTable: 'JSON',
  Table: 'Table',
  CheckboxList: 'CheckboxList',
  ZipCode: 'ZipCode',
  Label: 'label',
  Button: 'Button',
  Year: 'Year',
  TextNumber: 'TextNumber',
  Badge: 'Badge',
  NumericText: 'NumericText'
};

export const ApprovedStatus = {
  PendingApproval: 3,
  Approved: 4,
  AutoAllocated: 2,
  RequestedChanges: 9,
  Draft: 5,
  Historical: 10
};
